class UpsellProduct extends HTMLElement {
  constructor() {
    super();
    this.description = this.querySelector(".product-item-meta__description");
    this.showMoreButton = this.querySelector(".product-item-meta__description-show-more");
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.showMoreButton !== null) this.showMoreButton.addEventListener("click", this.showMore.bind(this));
  }

  showMore() {
    this.description.classList.toggle("expanded");
    
    if (this.description.classList.contains('expanded')) {
      this.showMoreButton.textContent = this.showMoreButton.dataset.openedText;
    } else {
      this.showMoreButton.textContent = this.showMoreButton.dataset.initialText;
    }
  }
}
customElements.define("upsell-product", UpsellProduct);